import { Directive, ElementRef, Input } from '@angular/core';
import { SlIdContext } from './sl-id-context';

@Directive({ selector: '[sl-aria-controls]' })
export class SlAriaControlsDirective {
  constructor(private el: ElementRef, private ids: SlIdContext) {}

  @Input('sl-aria-controls')
  set localId(value: string) {
    if (!value) {
      this.el.nativeElement.removeAttribute('aria-controls');
      return;
    }
    this.el.nativeElement.setAttribute('aria-controls', this.ids.id(value));
    this.el.nativeElement.removeAttribute('sl-aria-controls');
  }
}
